import * as Library from '../../../core/library/index';

export class Color {
  public colorCd: string;
  public marketingName: string;
  public colorHexCd: string;
  public nvsName: string;

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    this.colorCd = Library.init(options, 'colorCd');
    this.marketingName = Library.init(options, 'marketingName');
    this.colorHexCd = Library.init(options, 'colorHexCd');
    this.nvsName = Library.init(options, 'nvsName');
  }
}
